import { CircleUserRound } from "lucide-react";

export const TopBar = ({ user, onAccount }) => (
  <header className="top-bar">
    <span className="wordmark" data-testid="app-wordmark">LUCHADOR</span>
    <button type="button" className="account-trigger" onClick={onAccount} aria-label="Apri profilo" data-testid="account-open-button">
      <span className="account-meta"><span className="online"><i />ONLINE</span><span data-testid="signed-in-name">{user.name.split(" ")[0]}</span></span>
      <CircleUserRound size={22} strokeWidth={1.5} aria-hidden="true" />
    </button>
  </header>
);